const PATHS = {
  AUCTIONS: "/",
  AUCTIONS_MYAUCTIONS: "/my-auctions",
  AUCTIONS_MYBIDS: "/my-bids",
  AUCTIONS_ID: "/:id",
};

export default PATHS;
